import { render } from "./G01ItemListGroup.vue?vue&type=template&id=c95cf8de&scoped=true&ts=true"
import script from "./G01ItemListGroup.vue?vue&type=script&lang=ts"
export * from "./G01ItemListGroup.vue?vue&type=script&lang=ts"

import "./G01ItemListGroup.vue?vue&type=style&index=0&id=c95cf8de&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c95cf8de"]])

export default __exports__